export enum VisitorType {
    VISITOR = 'VISITOR', VISITORGROUP = 'VISITORGROUP'
}


export class PersonalVisitFilterModel {
    filterText = '';
    visitorTypes = new Array<VisitorType>();
    filterExternalKey: string;
    tableColumns: string;
    sortColumn: string;
    sortDescending: boolean;
    resetTableSort = false;
}
